import React from 'react'
import Heading from '../Heading/Heading'
import './Contact.css'

const Contact = () => {
  return (
    <>
        <div  id="contact">
        <Heading thinText={'Get'} boldText={'In Touch'}/>
        <div className="contactContainer">
            <div className="contactDiv">
                <h3 className="title">Get In Touch</h3>
                <form>
                    <input type="text" placeholder='Your Name'/>
                    <input type="text" placeholder='Your Email'/>
                    <input type="number" placeholder='Your Phone'/>
                    <textarea placeholder='Write A Message'></textarea>
                    <div className='btn'>SEND MESSAGE</div>
                </form>
            </div>
            <div className="contactDiv active">
                <h3 className="title">My Contact Details</h3>
                <div className='info'>
                    <span className="bold">Email</span>
                    <span className="lite">xyz@gmail.com</span>
                </div>
                <div className='info'>
                    <span className="bold">Phone</span>
                    <span className="lite">+91 897654321</span>
                </div>
                <div className='info'>
                    <span className="bold">FAX</span>
                    <span className="lite">+91 897654321</span>
                </div>
                <div className='info'>
                    <span className="bold">Addreess</span>
                    <span className="lite">San Francisco, CA
                    4th Floor8 Lower
                    San Francisco street, M1 50F</span>
                </div>
            </div>
        </div>
        </div>
    </>
  )
}

export default Contact